import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import ReCAPTCHA from 'react-google-recaptcha'

import Input from 'components/input'
import Select from 'components/select'
import PrimaryButton from 'components/primary-button'

import ForwardArrowIcon from 'icons/forward-arrow.svg'

import styles from './form.css'

const SRC = '//www.googleadservices.com/pagead/conversion/991632474/?label=MRQGCKjzwmgQ2rjs2AM&amp;guid=ON&amp;script=0'

const Form = ({
  errors,
  isSubmitted,
  markets,
  onChange,
  onSubmit,
  onVerifyCallback,
  recaptchaSiteKey,
  staticUrl,
}) => (
  <div
    styleName="container"
    style={{ backgroundImage: `url(${staticUrl}/${require('images/form-bg.png')})` }}
  >
    <div styleName="wrapper">
      <h1 styleName="title">
        {isSubmitted ? 'Welcome to YPlan Ticketing' : 'Ready to start?'}
      </h1>
      <p styleName="text">
        {isSubmitted ?
          'Please check your email to complete your registration and start selling tickets.'
        :
          'Fill out this short form to start selling your events online.'
        }
      </p>

      {isSubmitted &&
        <img
          alt=""
          height="1"
          src={SRC}
          styleName="conversion"
          width="1"
        />
      }

      <form styleName={isSubmitted ? 'form-hide' : 'form-show'} onSubmit={onSubmit}>
        <div styleName="row">
          <Input
            error={errors && !!errors.organisationName}
            name="organisationName"
            placeholder="Your organisation"
            onChange={onChange}
          />
        </div>
        <div styleName="row">
          <Select
            error={errors && !!errors.market}
            name="market"
            placeholder="Where is your event?"
            options={markets.map(market => ({ label: market.name, value: market.id.toString() }))}
            onChange={onChange}
          />
        </div>
        <div styleName="row">
          <Input
            error={errors && !!errors.email}
            name="email"
            placeholder="Your email"
            onChange={onChange}
          />
        </div>
        <div styleName="row">
          <span styleName={errors && !!errors.gRecaptchaResponse ? 'captcha-invalid' : 'captcha-valid'}>
            <ReCAPTCHA sitekey={recaptchaSiteKey} onChange={onVerifyCallback} />
          </span>
        </div>
        <div styleName="row">
          <PrimaryButton fluid label="Sign Up" />
          <ForwardArrowIcon styleName="signup-arrow" />
        </div>
      </form>
    </div>
  </div>
)

Form.propTypes = {
  errors: PropTypes.object,
  isSubmitted: PropTypes.bool,
  markets: PropTypes.array,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onVerifyCallback: PropTypes.func,
  recaptchaSiteKey: PropTypes.string,
  staticUrl: PropTypes.string,
}

export default CSSModules(Form, styles)



/** WEBPACK FOOTER **
 ** ./src/containers/ticketing-page/form/form.js
 **/